import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Main from 'layouts/Main';
import Container from 'components/Container';
import { Content ,Footer} from './components';

import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

const analytics = Analytics({
  app: 'awesome-app',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-X34JYK01Q0']
    })
  ]
})

analytics.page()


const CompanyTerms = () => {
  const theme = useTheme();

  return (
    <Main>



      

            <Container >
              <Content/>
            </Container>
          
         
          
       
    
    </Main>
  );
};

export default CompanyTerms;
